import CirgsCustomerDetails from './CirgsCustomerDetails';

export default CirgsCustomerDetails;
